export default __webpack_public_path__ + "static/media/slider6.2bb12c42.png";